export default "__VITE_ASSET__BMY7bMm4__"